module.exports = __webpack_public_path__ + "img/remortCardClearAct.f5f56984.png";